import React from 'react'

import { JobShort } from '../JobShort'

export const Shorts: React.FC = () => {
  return <JobShort />
}
